/// <amd-module name="Agile/Sprints/Directory/SprintDirectory" />
import { IDirectoryViewState } from "Agile/Directory/DirectoryContracts";
import { getDirectoryProviderProps, IDirectorySagaContext } from "Agile/Directory/Redux/getDirectoryProviderProps";
import { ArtifactName } from "Agile/Sprints/Directory/Resources";
import { AreaName, LOAD_DIRECTORY } from "Agile/Sprints/Directory/SprintDirectoryConstants";
import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { SprintDirectoryModule } from "Redux/SprintDirectoryModule";
import { ConnectedSprintDirectoryContentView } from "SprintDirectoryContentView";
import { ISprintDirectoryArtifact } from "SprintDirectoryContracts";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IRootProviderProps, RootProvider } from "VSS/Redux/Deprecated/RootProvider";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";

export class SprintDirectory extends VssComponent {
    private _hubViewState: VssHubViewState;
    private _providerProps: IRootProviderProps<IDirectorySagaContext, IDirectoryViewState<ISprintDirectoryArtifact>>;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);
        this._hubViewState = new VssHubViewState(context.pageContext);
        this._providerProps = getDirectoryProviderProps(
            {
                myDataProviderId: "ms.vss-work-web.sprints-hub-directory-data-provider",
                allDataProviderId: "ms.vss-work-web.sprints-hub-all-directory-data-provider",
                hubName: AreaName
            },
            this._hubViewState,
            context.pageContext,
            AreaName
        );
    }

    public render(): JSX.Element {
        return (
            <RootProvider {...this._providerProps}>
                <DynamicModuleLoader modules={[SprintDirectoryModule]}>
                    <ConnectedSprintDirectoryContentView
                        artifactIcon={{ iconName: "Sprint" }}
                        artifactName={ArtifactName}
                        hubViewState={this._hubViewState}
                        ttiScenarioProps={{
                            areaName: AreaName,
                            featureName: LOAD_DIRECTORY
                        }}
                    />
                </DynamicModuleLoader>
            </RootProvider>
        );
    }
}

VssComponent.register("sprintDirectory", SprintDirectory);
